export function StatementsCtrl (
  $q,
  $rootScope,
  $sce,
  $scope,
  $translate,
  $window,
  companyMessages,
  confirm,
  constraints,
  customers,
  messages,
  sessionObjAPI,
  tableApi,
  workshopAPI
) {

  $scope.companyMessages   = companyMessages;
  $scope.constraints       = constraints;
  $scope.customers         = customers || [];
  $scope.loaded            = true;
  $scope.selectedCustomers = [];
  $scope.tableCacheKey     = 'statements';

  $scope.customer_bulk_statements = {
    body   : $scope.companyMessages.statement_email_message,
    subject: `${ $translate.instant('MENU_SPACE.STATEMENT') } - ${ sessionObjAPI.company().company_name }`
  };

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    as_at          : '*',
    begin_date     : '*',
    constraint_type: '*',
    end_date       : '*',
    include_paid   : false,
    statement      : false,
  });

  $scope.tableSettings = {
    broadcast: 'filterStatements',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'customer.display_name',
        header: {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER')
        },
      },
      {
        field : 'customer.email',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.EMAIL')
        },
      },
      {
        field : 'customer.balance',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      },
      {
        field : 'contact_type',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.TYPE')
        },
      }
    ],
    empty: {
      text: $translate.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/customer_list_for_statements_count', [
        $scope.filtering.begin_date,
        $scope.filtering.end_date,
        $scope.filtering.include_paid,
        $scope.filtering.as_at,
        $scope.filtering.statement,
        $scope.filtering.constraint_type
      ])
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'customer.display_name'
    })
  };

  $scope.getCustomers = ( params ) => {
    return workshopAPI.get('/customers/customer_list_for_statements', [
      $scope.filtering.begin_date,
      $scope.filtering.end_date,
      $scope.filtering.include_paid,
      $scope.filtering.as_at,
      $scope.filtering.statement,
      params.field,
      params.direction,
      $scope.filtering.constraint_type,
      params.offset,
      params.pageSize
    ])
    .then(customers => {
      $scope.customers = customers;

      $scope.getRowColor();

      return $scope.customers;
    });
  };

  $scope.getRowColor = function () {
    angular.forEach($scope.customers, customer => {
      customer.selected = $scope.selectedCustomers.map(obj => obj.id)
      .includes(customer.customer.id);
    });
  };

  $scope.onRowClick = function (row) {
    let index = -1;

    for (let i = 0; i < $scope.selectedCustomers.length; i++) {
      if ($scope.selectedCustomers[i].id === row.customer.id) {
        index = i;
        i = $scope.selectedCustomers.length;
      }
    }

    index >= 0 ?
      $scope.selectedCustomers.splice(index, 1):
      $scope.selectedCustomers.push({ id: row.customer.id, contact_type: row.contact_type });

    $scope.getRowColor();
  };

  $scope.process = function () {
    if ($scope.selectedCustomers.length <= 0) {
      messages.show($translate.instant('CUSTOMER_SPACE.STATEMENTS.NO_CUSTOMERS_SELECTED'), 'error');
    }
    else {
      if (!$scope.filtering.statement && $scope.filtering.include_paid && $scope.filtering.begin_date === '*') {
        messages.error($translate.instant('GENERAL_SPACE.ERROR_MESSAGE.PROVIDE_BEGIN_DATE'));

        return $q.reject();
      }
      else if ($scope.filtering.statement && $scope.filtering.as_at === '*') {
        messages.error($translate.instant('GENERAL_SPACE.ERROR_MESSAGE.PROVIDE_AS_AT_DATE'));

        return $q.reject();
      }

      confirm.generic($translate.instant('JS_SPACE.CONFIRM.STATEMENTS_SEND_CONFIRM'))
      .then(() => {
        return workshopAPI.post('/customers/statements_separate', {
          constraint_type: $scope.filtering.constraint_type,
          customers      : $scope.selectedCustomers
        }, 'customers');
      })
      .then(customers => {
        if (customers.email_count) {
          const settings = $scope.filtering.statement ? {
            'email'    : customers.email,
            'as_at'    : $scope.filtering.as_at,
            'statement': $scope.filtering.statement
          }: {
            'email'       : customers.email,
            'begin_date'  : $scope.filtering.begin_date,
            'end_date'    : $scope.filtering.end_date,
            'include_paid': $scope.filtering.include_paid,
            'statement'   : $scope.filtering.statement
          };

          workshopAPI.post('/reports/jasper_statements_bulk', {
            email: $scope.customer_bulk_statements,
            settings
          });
        }

        return customers;
      })
      .then(customers => {
        if (customers.email_count) {
          messages.show(`${ customers.email_count } ${ $translate.instant('CUSTOMER_SPACE.STATEMENTS.STATEMENTS_EMAILED') }`, 'success');
        }

        return customers;
      })
      .then(customers => {
        if (customers.print_count) {
          const params = $scope.filtering.statement ? {
            'print'    : customers.print,
            'as_at'    : $scope.filtering.as_at,
            'statement': $scope.filtering.statement
          } : {
            'print'       : customers.print,
            'begin_date'  : $scope.filtering.begin_date,
            'end_date'    : $scope.filtering.end_date,
            'include_paid': $scope.filtering.include_paid,
            'statement'   : $scope.filtering.statement
          };

          const url = $scope.filtering.statement
            ? '/reports/jasper_statements_306090_print'
            : '/reports/jasper_statements_print';

          messages.show(`${ customers.print_count } ${ $translate.instant('CUSTOMER_SPACE.STATEMENTS.STATEMENTS_PRINTED') }`, 'success');

          return workshopAPI.post(url, params, 'print', null, {
            responseType: 'arraybuffer'
          });
        }
      })
      .then(response => {
        if (response) {
          const file    = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);

          $window.open($sce.trustAsResourceUrl(fileURL));
        }
      })
      .then(() => {
        $scope.selectedCustomers = [];
      })
      .catch(err => {
        messages.error(err);
      });
    }
  };

  $scope.selectAll = function () {
    $scope.selectingAll = true;

    $scope.tableSettings.pagination.queryCount()
    .then(count => {
      return workshopAPI.get('/customers/customer_list_for_statements', [
        $scope.filtering.begin_date,
        $scope.filtering.end_date,
        $scope.filtering.include_paid,
        $scope.filtering.as_at,
        $scope.filtering.statement,
        $scope.tableSettings.sorting.field,
        $scope.tableSettings.sorting.direction,
        $scope.filtering.constraint_type,
        0,
        count
      ])
      .then(customers => {
        $scope.selectedCustomers = [];

        angular.forEach(customers, customer => {
          $scope.selectedCustomers.push({ id: customer.customer.id, contact_type: customer.contact_type });
        });

        $scope.getRowColor();
      })
      .catch(err => {
        messages.error(err);
      })
      .finally(() => {
        $scope.selectingAll = false;
      });
    });
  };

  $scope.selectNone = function () {
    $scope.selectedCustomers = [];
    $scope.getRowColor();
  };

  $scope.$watch('[filtering.constraint_type, filtering.as_at, filtering.begin_date, filtering.end_date, filtering.include_paid, filtering.statement]', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      $scope.selectNone();
      window['filterStatements']($scope.filtering);
    }
  }, true);
};